/* eslint-disable @typescript-eslint/indent */
import { type ReadonlySignal, type Signal } from '@preact/signals-react'
import { type Dayjs } from 'dayjs'

export interface TApplication
  extends Record<
    string,
    | string
    | null
    | boolean
    | number
    | Date
    | undefined
    | Dayjs
    | EApplicationCreateMode
    | TApplication
    | TApplication[]
    | string[]
  > {
  ValidacionRpa?: string // SI o NO según resultado de consulta RPA
  detalleInhabilitacion?: string
  inhabilitado?: boolean
}

export const enum EApplicationCreateMode {
  OFFLINE = 'offline',
  ONLINE = 'online',
}

export const enum EApplicationType {
  IMPROVEMENT = 'mejora',
  RURAL_LIVING = 'vivienda rural',
  URBAN_LIVING = 'vivienda urbana',
}

export const enum EApplicationStatus {
  APPROVED = 'Aprobado',
  CHANGES_APPLIED = 'Corregido',
  CHANGES_REQUIRED = 'Requiere corrección',
  COMPLETED = 'Completado / Diligenciado',
  CORRECTLY_FILLED = 'Correctamente diligenciado',
  DISABLED = 'Inhabilitado',
  FINISHED = 'Archivado / Finalizado',
  IMPORT = 'Importar',
  IN_PROCESS = 'En proceso',
  IN_REVIEW = 'En revisión',
  OFFLINE = 'Sin sincronizar',
  REJECTED = 'Rechazado',
  WITHOUT_START = 'Sin iniciar',
}

export const enum EApplicationViewMode {
  EDIT = 'edit',
  VIEW = 'view',
}

export interface TApplicationStateLoading {
  changeStatus: { id?: boolean | number | string; status?: EApplicationStatus }
  deletingRow: boolean | number | string
  export: boolean
  getAll: boolean
  getById: number | boolean | string
  import: boolean
  saving: boolean
  savingRow: boolean
}

export interface TApplicationFilters {
  status: EApplicationStatus | null
  text: string | null
  type: EApplicationType | null
}

export interface TApplicationsState {
  applications: Signal<TApplication[]>
  canCreateApplication: ReadonlySignal<boolean>
  currentApplication: Signal<TApplication | null>
  currentApplicationType: Signal<EApplicationType | null>
  currentEntityFilesData: Signal<Record<string, string>>
  currentEntityTableData: Signal<TApplication[]>
  filteredApplications: ReadonlySignal<TApplication[]>
  filters: Signal<TApplicationFilters>
  importApplicationType: Signal<EApplicationType | null>
  loading: Signal<TApplicationStateLoading>
  // NUEVO: Modal de inhabilitación
  modalInhabilitacion: Signal<{
    cedula?: string
    detalle: string
    visible: boolean
  }>
  openImportModal: Signal<boolean>
  showCreateAlert: Signal<boolean>
  showFilters: Signal<boolean>

  viewMode: Signal<{ edit: boolean; view: boolean }>
}
